import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { FiHome, FiBell, FiCalendar, FiUsers, FiSettings, FiLogOut, FiMenu, FiX } from 'react-icons/fi';
import './Sidebar.css';

const Sidebar = ({ expanded, onToggle }) => {
  const { logout } = useAuth();
  const [collapsed, setCollapsed] = useState(window.innerWidth <= 768);
  const [userName, setUserName] = useState('');
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  
  useEffect(() => {
    // Obtener el nombre del usuario del localStorage
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    setUserName(user.name || 'Usuario');
    
    // Listener para el redimensionamiento de la ventana
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      
      // Solo actualizamos el estado collapsed si estamos en desktop
      if (!mobile) {
        // No cambiamos el collapsed automáticamente al cambiar el tamaño
        // Solo actualizamos el estado isMobile
      }
    };
    
    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [collapsed]);
  
  const toggleSidebar = () => {
    if (isMobile) {
      // En móvil, controlamos el sidebar a través de expanded prop
      onToggle && onToggle(!expanded);
    } else {
      // En desktop, controlamos localmente el collapsed
      setCollapsed(!collapsed);
    }
  };
  
  const handleLinkClick = () => {
    if (isMobile && expanded) {
      // Cerrar el sidebar al hacer clic en un enlace (solo en móvil)
      onToggle && onToggle(false);
    }
  };
  
  // Determinar la clase correcta para el sidebar basado en el estado actual
  const sidebarClass = isMobile
    ? `sidebar ${expanded ? 'expanded' : ''}`
    : `sidebar ${collapsed ? 'collapsed' : ''}`;
  
  return (
    <>
      {/* Overlay para móvil cuando el sidebar está expandido */}
      {isMobile && expanded && (
        <div 
          className="sidebar-overlay visible"
          onClick={() => onToggle && onToggle(false)}
        ></div>
      )}
      
      <div className={sidebarClass}>
        <div className="sidebar-header">
          {/* Mostrar logo/nombre solo cuando corresponde */}
          {(!collapsed || (isMobile && expanded)) && <h2 className="logo">{userName}</h2>}
          <button className="toggle-button" onClick={toggleSidebar} aria-label="Toggle sidebar">
            {isMobile && expanded ? <FiX /> : <FiMenu />}
          </button>
        </div>
        <nav className="sidebar-menu">
          <NavLink 
            to="/" 
            className={({ isActive }) => isActive ? 'active' : ''}
            onClick={handleLinkClick}
          >
            <FiHome className="icon" />
            <span className="menu-text">Panel</span>
          </NavLink>
          <NavLink 
            to="/notifications" 
            className={({ isActive }) => isActive ? 'active' : ''}
            onClick={handleLinkClick}
          >
            <FiBell className="icon" />
            <span className="menu-text">Notificaciones</span>
          </NavLink>
          <NavLink 
            to="/calendar" 
            className={({ isActive }) => isActive ? 'active' : ''}
            onClick={handleLinkClick}
          >
            <FiCalendar className="icon" />
            <span className="menu-text">Agenda</span>
          </NavLink>
          <NavLink 
            to="/clients" 
            className={({ isActive }) => isActive ? 'active' : ''}
            onClick={handleLinkClick}
          >
            <FiUsers className="icon" />
            <span className="menu-text">Clientes</span>
          </NavLink>
          <NavLink 
            to="/settings" 
            className={({ isActive }) => isActive ? 'active' : ''}
            onClick={handleLinkClick}
          >
            <FiSettings className="icon" />
            <span className="menu-text">Configuración</span>
          </NavLink>
        </nav>
        <div className="sidebar-footer">
          <button onClick={logout} className="logout-button">
            <FiLogOut className="icon" />
            <span className="menu-text">Cerrar sesión</span>
          </button>
        </div>
      </div>
    </>
  );
};

export default Sidebar;